import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { BusinessOfferManagerHandler } from '../../providers/business-offer-handler';
import { BusinessOfferManagerPage } from '../business-offer-manager/business-offer-manager';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-offer-list',
  templateUrl: 'business-offer-list.html',
})
export class BusinessOfferListPage {
	offers: any;
	hasOffers: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;

	loadingMsg: any = "Loading...";
	isRefreshing: boolean = false;
	lastRequestReturnedValues: boolean = false;

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

  	constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public offerManagerHandler: BusinessOfferManagerHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public globals: Globals,
		) {
		this.filePath = this.globals.fileUrl;
  	}

  	ionViewWillEnter() {
		this.load(null);
	}	

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.isRefreshing = true;

		this.params.page++;

		this.load(()=>{
			this.isRefreshing = false;
			
			infiniteScroll.complete();
		});
	}

	printCategory(categoryId){
		let cat = this
				.globals
				.productCategories
				.filter(
          			category => category.Id === categoryId
          		)

		return cat[0].Label;
	}		

	createOffer(){
	    this.navCtrl.push(BusinessOfferManagerPage, {
	      offer: {}
	    });		
	}

	manageOffer($e, offer){
	    this.navCtrl.push(BusinessOfferManagerPage, {
	      offer: offer
	    });				
	}

	load(cb){
		this.isLoading = (!this.isRefreshing) ? true : false;
		
		this.offerManagerHandler.getOffers((offers)=>{
			this.offers = offers;

			this.hasOffers = this.offers.length>0;

			this.isLoading = false;

			if(typeof cb == "function")
				cb()			
		})
	}

}



// WEBPACK FOOTER //
// ./src/pages/business-offer-list/business-offer-list.ts